/* __next_internal_client_entry_do_not_use__ ResponsibleConsumption auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=3509%3A819))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:51:25.323Z
 */ export var ResponsibleConsumption = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M10.464 17.1691H6.59995C5.53193 17.1691 4.4879 16.8524 3.59987 16.2591C2.71185 15.6657 2.01972 14.8224 1.611 13.8356C1.20229 12.8489 1.09535 11.7632 1.30371 10.7157C1.51207 9.66816 2.02637 8.70597 2.78158 7.95077C3.53678 7.19556 4.49897 6.68126 5.54647 6.4729C6.59396 6.26454 7.67972 6.37148 8.66644 6.78019C9.65317 7.18891 10.4965 7.88104 11.0899 8.76906C11.6832 9.65709 12 10.7011 12 11.7691C12 12.8372 12.3167 13.8812 12.91 14.7692C13.5034 15.6572 14.3467 16.3494 15.3335 16.7581C16.3202 17.1668 17.4059 17.2737 18.4534 17.0654C19.5009 16.857 20.4631 16.3427 21.2183 15.5875C21.9735 14.8323 22.4878 13.8701 22.6962 12.8226C22.9046 11.7751 22.7976 10.6894 22.3889 9.70265C21.9802 8.71593 21.2881 7.87257 20.4 7.27921C19.512 6.68585 18.468 6.36914 17.4 6.36914C16.572 6.36914 15.18 6.70686 13.8308 7.97371",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M8.00903 14.7092L10.469 17.1692L8.00903 19.6309",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "ResponsibleConsumption", {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24"
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
